export default {_name:'stepper.step.tabbed',module:'Card/Pane',view:'Element/Stepper/Step/Tabbed',options:{key:'tabbedStep',xs:12}}